import React from 'react';
import { useLocation } from '../nav';
import { Splash } from '../pages/Splash';
import { Login } from '../pages/Login';
import { Home } from '../pages/Home';
import { Chat } from '../pages/Chat';
import { Transfer } from '../pages/Transfer';
import { Draft } from '../pages/Draft';
import { Review } from '../pages/Review';
import { Success } from '../pages/Success';
import { History } from '../pages/History';
import { Bills } from '../pages/Bills';
import { BillPay } from '../pages/BillPay';
import { Profile } from '../pages/Profile';
import { Account } from '../pages/Account';

/** Renders the live app screen for the current in-memory route. */
export function ScreenView() {
  const {
    pathname
  } = useLocation();
  switch (pathname.split('?')[0]) {
    case '/':
    case '/splash':
      return <Splash data-id="element-148" data-mp="11r952olxgtk6" />;
    case '/login':
      return <Login data-id="element-149" data-mp="11q7v6ngned41" />;
    case '/home':
      return <Home data-id="element-150" data-mp="11r0vb5l3q4d7" />;
    case '/chat':
      return <Chat data-id="element-151" data-mp="15smc320rb2so" />;
    case '/transfer':
      return <Transfer data-id="element-152" data-mp="15rjn4zmzvafe" />;
    case '/draft':
      return <Draft data-id="element-153" data-mp="15qrt3t91pkr8" />;
    case '/review':
      return <Review data-id="element-154" data-mp="3hf3bfms5d049" />;
    case '/success':
      return <Success data-id="element-155" data-mp="3he21jlmvajo4" />;
    case '/history':
      return <History data-id="element-156" data-mp="3cfibpa55knqh" />;
    case '/bills':
      return <Bills data-id="element-157" data-mp="3cgjobj1thiab" />;
    case '/bill':
      return <BillPay data-id="element-158" data-mp="3cga6iiqxehfp" />;
    case '/profile':
      return <Profile data-id="element-159" data-mp="37oidm1karzme" />;
    case '/account':
      return <Account data-id="element-160" data-mp="37nh1ruvgj93m" />;
    default:
      return <Splash data-id="element-161" data-mp="37mfgkxkq9686" />;
  }
}